angular.module("ainapp")
    .controller("purchaseQueueController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Purchase Queue";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.filter = {
                    ProductIds: [],
                }
                $scope.load = false;

            }
            $scope.Init();

            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.productInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectProductOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.ProductIds = $scope.filter.ProductIds;

                        MainService.PurchaseQueueInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })


                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Product.Name": {
                                type: "string",
                                editable: false,
                            },
                            PurchaseDate: {
                                type: "date",
                                editable: false,
                            },
                            PurchaseQty: {
                                type: "number",
                                editable: false,
                            },
                            UsedQty: {
                                type: "number",
                                editable: false,
                            },
                            BalanceQty: {
                                type: "number",
                                editable: false,
                            },
                            Cost: {
                                type: "number",
                                editable: false,
                            },
                            InvNo: {
                                type: "string",
                                editable: false,
                            },
                            InvType: {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                group: [{
                    field: "Product.Name",
                    }],
            });

            $scope.KendoGridOptions = {
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "Product.Name",
                        title: "Product",
                        width: "220px",
                        hidden: true,
                        },
                    {
                        field: "PurchaseDate",
                        title: "Date",
                        width: "100px",
                        template: "<p >{{dataItem.PurchaseDate |date: 'dd/MM/yyyy'}}</p>"
                     },
                    {
                        field: "InvNo",
                        title: "InvNo",
                        width: "100px",
                     },
                    {
                        field: "InvType",
                        title: "InvType",
                        width: "100px",
                     },

                    {
                        field: "PurchaseQty",
                        title: "Quantity",
                        width: "100px",
                     },
                    {
                        field: "UsedQty",
                        title: "Used",
                        width: "100px",
                     },
                    {
                        field: "BalanceQty",
                        title: "Balance",
                        width: "100px",
                     },
                    {
                        field: "Cost",
                        title: "Cost",
                        width: "100px",
                     },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'>Details</button> ",
                        width: '50px',
                        sticky: true
                        },


                    ],
            };

            $scope.Filter = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.QueueDetails = [];
            $scope.View = function (data) {

                $scope.QueueDetails = [];
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.GetPurchaseQueueDetails(data.Id).then(function (response) {
                    if (response.data) {
                        $scope.QueueDetails = response.data;
                        $('#viewDetailModal').modal('show');
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                })

            }




        }])
